import React, { ReactNode, ReactNodeArray } from 'react'
import { useCustomSnackbar } from '../CustomSnackbar/hook'
import { startFileDownload } from '../../services/file'

export interface IDownloadFileLink {
  fileId: string
  children: ReactNode | ReactNodeArray
  disabled?: boolean
}

export const DownloadFileLink = ({
  fileId,
  children,
  disabled,
}: IDownloadFileLink) => {
  const [, setSnackbarMessage] = useCustomSnackbar()
  const downloadFile = async () => {
    const errorMessage = await startFileDownload(fileId)
    if (errorMessage) {
      setSnackbarMessage(errorMessage)
    }
  }
  return (
    <div
      title={
        !disabled
          ? 'Source file'
          : 'Impossible to download as the source file is infected'
      }
      onClick={() => {
        if (!disabled) {
          downloadFile()
        }
      }}
      style={{ cursor: 'pointer' }}
    >
      {children}
    </div>
  )
}
